module.exports = __webpack_public_path__ + "img/rightCode.954da1e0.png";